const lightTheme = {
  colors: {
    primary: '#006341',
    secondary: '#C9A24E',
    secondaryStrong: '#8B6B13',
    background: '#F5F7F6',
    backgroundAlt: '#EEF2F0',
    surface: '#FFFFFF',
    surfaceMuted: '#FAFBFA',
    accent: '#E5E8E6',
    textDark: '#1E1E1E',
    textLight: '#F8F8F8',
    muted: '#6F7B74',
    outline: 'rgba(0, 99, 65, 0.18)',
    divider: 'rgba(0, 25, 16, 0.08)',
  },
  fonts: {
    ar: "'Tajawal', 'Cairo', system-ui, sans-serif",
    en: "'Poppins', system-ui, sans-serif",
  },
  layout: {
    maxWidth: '1200px',
    radiusLg: '24px',
    radiusMd: '16px',
    radiusSm: '10px',
    shadowSoft: '0 20px 60px rgba(0, 0, 0, 0.08)',
  },
  breakpoints: {
    sm: '480px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
  },
};

const darkTheme = {
  ...lightTheme,
  colors: {
    primary: '#00A86B',
    secondary: '#D4AF37',
    secondaryStrong: '#F5D76E',
    background: '#0F1419',
    backgroundAlt: '#1A1F26',
    surface: '#1E2328',
    surfaceMuted: '#252A30',
    accent: '#2A2F36',
    textDark: '#E8E8E8',
    textLight: '#F8F8F8',
    muted: '#9CA3AF',
    outline: 'rgba(0, 168, 107, 0.25)',
    divider: 'rgba(255, 255, 255, 0.1)',
  },
  layout: {
    ...lightTheme.layout,
    shadowSoft: '0 20px 60px rgba(0, 0, 0, 0.4)',
  },
};

const theme = lightTheme;

export { lightTheme, darkTheme };
export default theme;
